var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, createStylesContext } from '@chakra-ui/react';
const [StylesProvider, useStyles] = createStylesContext('Select');
const Option = (_a) => {
    var { value, children, isSelected, onClickOption } = _a, props = __rest(_a, ["value", "children", "isSelected", "onClickOption"]);
    const styles = useStyles();
    return (_jsx(Button, Object.assign({ flex: "none", textAlign: "left", whiteSpace: "nowrap", overflowX: "hidden", textOverflow: "ellipsis", __css: styles.option }, props, { "aria-selected": isSelected, sx: {
            '&[aria-selected=true]': {
                bg: '#e6f4ff',
                color: 'gray.800',
                fontWeight: 'bold',
            },
        }, onClick: () => onClickOption({ value, label: children }) }, { children: children })));
};
export { Option, StylesProvider };
export default Option;
